{
  "appointment": {
    "CONFIRMATION_NUMBER": "Confirmation #",
    "APPOINTMENT_ID": "ID du rendez-vous",
    "APPOINTMENT_DATE": "Date du RDV",
    "APPOINTMENT_TIME": "Heure du RDV",
    "APPOINTMENT_TIMEZONE": "Fuseau horaire",
    "APPOINTMENT_TYPE": "Type de rendez-vous",
    "SCHEDULED_DURATION": "Durée prévue (min)",
    "STATUS": "Statut",
    "ARRIVAL_DATE": "Date d'arrivée",
    "ARRIVAL_TIME": "Heure d'arrivée",
    "DEPARTURE_DATE": "Date de départ",
    "DEPARTURE_TIME": "Heure de départ",
    "DWELL_TIME": "Temps de séjour (min)",
    "ON_TIME": "Ponctualité (min)",
    "IN_PROGRESS_DATE": "Date de début (en cours)",
    "IN_PROGRESS_TIME": "Heure de début (en cours)",
    "WAIT_TIME": "Temps d'attente (min)",
    "PROCESSING_TIME": "Temps de traitement (min)",
    "WAREHOUSE": "Entrepôt",
    "DOCK": "Quai",
    "LOAD_TYPE": "Type de chargement",
    "LOAD_TYPE_DIRECTION": "Direction",
    "RESCHEDULE_COUNT": "Nombre de reports",
    "CREATED_BY": "Créé par",
    "CREATOR_TYPE": "Type de créateur",
    "CREATION_DATE": "Date de création",
    "LAST_UPDATED_BY": "Dernière mise à jour par",
    "LAST_UPDATE_DATE": "Date de dernière mise à jour",
    "LAST_UPDATE_TIME": "Heure de dernière mise à jour",
    "CARRIER_COMPANY": "Entreprise de transport",
    "CONTACT_NAME": "Nom du contact",
    "CONTACT_EMAIL": "Courriel du contact",
    "CONTACT_PHONE": "Téléphone du contact",
    "NOTES": "Notes",
    "TAGS": "Étiquettes",
    "CUSTOM_FIELDS": "Champs personnalisés",
    "EXTERNAL_VALIDATION_STATUS": "Statut de validation externe",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "Message d'erreur de validation externe",
    "CheckOut": "Sortie",
    "CheckInAdditionalAssetDetails": "Détails supplémentaires de l'actif à l'entrée",
    "InboundClaim": "Réclamation entrante",
    "OutboundClaim": "Réclamation sortante",
    "BookLoadType": "Type de chargement de la réservation",
    "AssetContainerDetails": "Détails du conteneur de l'actif",
    "AppointmentCompleted": "Rendez-vous terminé"
  },
  "assetVisit": {
    "id": "ID de la visite",
    "appointmentId": "ID du rendez-vous",
    "checkInDate": "Date d'entrée",
    "checkOutDate": "Date de sortie",
    "carrier": "Transporteur",
    "warehouseName": "Entrepôt",
    "currentStatus": "Statut",
    "licensePlate": "Plaque d'immatriculation",
    "visitType": "Type de visite",
    "dotNumber": "Numéro DOT",
    "phone": "Téléphone",
    "isPlanned": "Planifiée",
    "driverNotes": "Notes du chauffeur",
    "checkInAcknowledged": "Entrée confirmée",
    "firstName": "Prénom (vérification d'identité)",
    "lastName": "Nom (vérification d'identité)",
    "birthdate": "Date de naissance (vérification d'identité)",
    "idValidationEmail": "Courriel (vérification d'identité)",
    "idValidationPhone": "Téléphone (vérification d'identité)"
  }
}
